<template>
    <div style="margin-left: 30px;" v-loading="loading">


        <div style="margin-bottom: 20px;text-align: center">
            <el-menu style="margin-top: -20px;" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"  @select="handleOpen">
                <el-menu-item index="1">
                    <span>基本设置</span>
                </el-menu-item>
                <el-menu-item index="2">
                    <span>修改记录</span>
                </el-menu-item>

                <el-menu-item index="3">
                    <span>二一组卷管理中心</span>
                </el-menu-item>
                <el-menu-item index="7">
                    <span slot="title">地区试卷的地区绑定</span>
                </el-menu-item>
                <el-tooltip class="item" effect="light" placement="left" :value=true>
                    <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i> 修改配置后请点击此处保存</b> </div>
                    <TemporaryLimit v-if="is_temporary" style="text-align: center;float: right;margin-top: 26px" buttonName="确定" @change="submit"></TemporaryLimit>
                    <el-button v-else style="text-align: center;float: right;margin-top: 26px" size="small" type=primary @click="submit()">确定</el-button>
                </el-tooltip>
            </el-menu>
        </div>
        <div v-if="activeIndex==2">
            <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
        </div>
        <div v-show="activeIndex==1">
            <el-alert
                title="警告提示"
                type="warning"
                description="学校一年组卷金额小于3000元 ，需填写下载总次数限制（合作金额*2），培训机构则按组卷合作金额换算组卷份数填写，且培训机构账号不能超过规定标准"  
                close-text="朕知道了" 
                show-icon>
            </el-alert>
            <product-head :params="params" @changeHead="changeHead"></product-head>
            <limit-configure ref="limit-configure" :params="form.limit_configure"
                             @handleData="handleData"></limit-configure>
            <div slot="footer" class="dialog-footer" style="text-align: center">

            </div>
        </div>
        <div v-if="activeIndex == 7"  class="demo-input-suffix">
            <p class="exp">注意事项：当前模块控制 校本-本校资源-地区试卷的左侧目录树的地区、学校展示隐藏</p>
            <el-menu :default-active="eliteShcoolIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="1">资源地区绑定</el-menu-item>
                <el-menu-item index="2">屏蔽学校</el-menu-item>
            </el-menu>
            <el-row :gutter="10" v-if="eliteShcoolIndex == 1">
                <el-col :span="10">
                    <div class="grid-content">
                        <el-scrollbar style="height:100%">
                            <elite-school-area v-if="activeIndex == 7 " :customer_id="$route.query['id']" :customer="params.customer">
                            </elite-school-area>
                        </el-scrollbar>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10" v-if="eliteShcoolIndex == 2">
                <el-col :span="3">
                    <el-button style="text-align: center;margin-top: 20px;margin-bottom: 20px;" type=primary size="small" @click="dialogTableVisible = true">+屏蔽学校</el-button>
                    <p style="float: right;font-size: small;">已屏蔽学校：</p>
                </el-col>
                <el-col :span="21">
                    <div class="grid-content" style="margin-top: 60px;">
                        <el-scrollbar style="height:100%">
                            <hide-school v-if="activeIndex == 7 " :customer_id="$route.query['id']" :params="form.limit_configure">
                            </hide-school>
                        </el-scrollbar>
                    </div>
                    <!-- 线索查重 -->
                    <elite-school v-if="dialogTableVisible" :display="dialogTableVisible" :customer="params.customer" :customer_id="$route.query['id']" @watchQueryRepeatClose="watchQueryRepeatClose"></elite-school>
                </el-col>
            </el-row>
        </div>
        <div v-show="activeIndex==3">
            <p>
                <b>（注：二一组卷中心的使用期限与二一组卷产品的时间一致）</b>
            </p>
            <MenuBind :customer_id="$route.query['id']" :product_id="form.product_id"></MenuBind>
        </div>
    </div>
</template>
<script>
    import LimitConfigure from "~/views/order/zujuan/limitConfigure.vue";
    import Config from "~/config/params";
    import ProductHead from "~/views/order/partial/product_head.vue";
    import RelationForm from "~/views/customer/relationForm.vue";
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import AccountService from "~/services/CustomerAccounts"
    import OrderService from "~/services/order";
    import Recorder from "~/views/order/recoder/base.vue";
    import EliteSchool from  "~/views/order/zujuan/eliteSchool.vue";
    import EliteSchoolArea from  "~/views/order/zujuan/eliteSchoolArea.vue";
    import HideSchool from  "~/views/order/zujuan/hideSchool.vue";
    import TemporaryLimit from "~/views/order/dialog/temporaryLimit.vue";
    import MenuBind from "~/views/customer/menu/MenuBind.vue";
    export default {
        components: {
            LimitConfigure,
            ProductHead,
            RelationForm,
            RelationDialog,
            EliteSchool,
            EliteSchoolArea,
            HideSchool,
            Recorder,
            TemporaryLimit,
            MenuBind
        },
        
        props: {
            params: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                activeIndex: '1',
                loading: true,
                validate_limit_configure: false,//针对子组件进行表单验证的标识
                showIsAlreadyRelation: false,
                showRelation: false,
                relationAccounts: [],
                form: {
                    product_id: '',
                    order_id: '',
                    limit_configure: {},
                    expire_type: ''
                },
                eliteShcoolIndex: '1',
                dialogTableVisible: false,
                is_temporary: false,
            }
        },
        //详细列表加载自动执行
        //保证展示的数据结构和新建数据结构一致
        //统一方便
        created() {
            if (typeof this.params.config != 'undefined' &&  this.params.config.length !=0) {
                this.form.limit_configure = Object.assign(this.form.limit_configure, this.params.config)
            } else {
                this.default_setting();
            }
            this.form.order_id = this.params.order_id;
            this.form.product_id = this.params.product_id;
            this.form.type = this.params.open_state;
            this.form.end_at = this.params.end_at;
            this.form.start_at = this.params.start_at;

            this.getRelationAccounts();
        },

        watch: {
            'form.limit_configure': {
                handler(newVal, oldVal) {
                    console.log('修改监听:', newVal, oldVal);
                    // 在这里执行你需要的操作，比如更新其他数据或调用方法
                    this.is_temporary = true;
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
        },

        methods: {
            handleOpen(key, keyPath) {
                this.activeIndex = key;
            },
            /**
             * 修改头部信息
             * @param data
             */
            changeHead(data) {
                this.form.type = data.type;
                this.form.end_at = data.end_at;
                this.form.start_at = data.start_at;
            },
            showAlreadyRelation() {
                this.showIsAlreadyRelation = true;
            },
            closeRelationDialog(show) {
                this.showRelation = show;
                this.showIsAlreadyRelation = show;
            },
            /**
             * 关联账号
             * */
            relationAccount(data) {
                this.relationAccounts = data;
            },
            /**
             * 移除账号
             * */
            removeAccount(data) {
                this.relationAccounts = this.relationAccounts.filter(i => {
                    return i.user_id != data.user_id;
                })
            },
            /**@description 监听子组件数据 */
            handleData(data) {
                this.form.limit_configure = data
            },
            /**
             * 提交
             */
            submit(expire_type = '') {
                if (this.is_submit) return false;
                this.is_submit = true;
                this.form.expire_type = expire_type;
                console.log('submit:',this.form);
                OrderService.reviseProduct(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.msg == 'success' ? Config.REVISE_NOTICE : res.msg,
                            type: 'success'
                        });
                    }
                    this.is_temporary = false;
                    this.is_submit = false;
                });
            },
            handleDialogConfigureShow() {
                if (!this.validate_limit_configure) {
                    this.$refs['limit-configure'].validateForm();
                    this.$message({
                        message: '请进行额度配置',
                        type: 'error'
                    })
                    return false;
                }
                this.$emit('handleDialogConfigureShow', this.form);
            },
            getRelationAccounts() {
                AccountService.accountFilter({customer_id: this.params.customer_id, service: 'zujuan'}).then(res => {
                    if (res.data) {
                        this.relationAccounts = res.data;
                    }
                    this.loading = false;
                })
            },
            default_setting() {
                let data = {};
                data.product_code = this.params.product_code;
                data.question_num = 50;
                data.paper_download = 150;
                let subjects = Config.getSubjects();
                subjects.unshift({
                    subject_id: 0,
                    subject_name: '所有科目',
                });
                data.batch = subjects.map(item => {
                    item.config = Object.assign({}, {
                        all: 0,
                        primary: -1,
                        middle: -1,
                        high: -1
                    });
                    global.periods.forEach(period => {
                        if (period == 1) {
                            item.config.primary = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                            item.config.primary = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                        } else if (period == 2) {
                            item.config.middle = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                            item.config.middle = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                        } else if (period == 3) {
                            item.config.high = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                            item.config.high = global.order_type == Config.TYPE_TRY_OUT ? 30 : 30;
                        }
                    })
                    return item;
                })
                this.form.limit_configure = data;
                this.validate_limit_configure = true;
            },
            handleSelect(key, keyPath) {
                this.eliteShcoolIndex = key;
            },

            watchQueryRepeatClose() {
                this.dialogTableVisible = false;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/zujuan/zujuanConfigure.vue